import type { FutyclubConfig } from "./types";

export const config: FutyclubConfig = {
  auth0: {
    domain: "authentication.futyclub.com",
    clientId: "6YVy0HBAv1VV9kLLfUbFehPnDRmqZyMB",
    audience: "https://api.futyclub.com/",
  },
  api: {
    serverUrl: "https://futyclub.com",
  },
  sentryDsn: "https://d53a8b5d05f5e8263267c15b8425676d@o4511137817952257.ingest.de.sentry.io/4511138156707920",
  posthogApiKey: "phc_zdD44QcmWfMbGdC8KEqJCasinW5Ega8Ny37VgGRuUynt",
};
